var BonusStages = /* @__PURE__ */ ((BonusStages2) => {
  BonusStages2[BonusStages2["all"] = -1] = "all";
  BonusStages2[BonusStages2["notActivated"] = 0] = "notActivated";
  BonusStages2[BonusStages2["activated"] = 1] = "activated";
  BonusStages2[BonusStages2["canceled"] = 2] = "canceled";
  BonusStages2[BonusStages2["expired"] = 3] = "expired";
  BonusStages2[BonusStages2["lost"] = 4] = "lost";
  BonusStages2[BonusStages2["wagerDone"] = 5] = "wagerDone";
  return BonusStages2;
})(BonusStages || {});
export {
  BonusStages
};
